import { Button } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";
import Router from "next/router";
import config from "@/libs/config";

export const BizsolReturnButton = () => {
  const onClick = () => {
    Router.push("/bizsol/redirect-login");
  };

  return (
    <div css={buttonWrapper}>
      <Button type="button" onClick={onClick}>
        {config.BIZSOL_DISPLAY_NAME}に戻る
      </Button>
    </div>
  );
};

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "30px",
  marginTop: "8px",
});
